import { useQuery } from "@tanstack/react-query";
import { ContactsQuery } from "../contacts.query";
import { getContacts } from "@/api";
import { Contact } from "../contacts.types";
import { createContext, useContext } from "react";

export type ContactContextType = {
  data: Contact | undefined;
  isLoading: boolean;
  refetch: () => void;
};

const ContactContext = createContext<ContactContextType | undefined>(undefined);

export const ContactProvider: React.FC<{
  children: React.ReactNode;
  contact_id: number;
}> = ({ children, contact_id }) => {
  const {
    data: contactInfo,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ContactsQuery.queryKeys.detail(contact_id),
    queryFn: () => getContacts({ client_id: contact_id }),
    select: (res) => res[0],
  });

  const contextValue: ContactContextType = {
    data: contactInfo,
    isLoading,
    refetch,
  };

  return (
    <ContactContext.Provider value={contextValue}>
      {children}
    </ContactContext.Provider>
  );
};

export const useContactContext = () => {
  const context = useContext(ContactContext);
  return context;
};
